import { Injectable } from '@angular/core';
import { Bodega } from '../model/Bodega';
import { UtilitiesService } from '../services/utilities.service';

import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';

@Injectable()
export class BodegaService {

  constructor(
    private _http:Http,
    private _utilities:UtilitiesService
    ) { }

    getBodegas() : Observable<Bodega[]> {
         
    let json = {   "Metodo": "getBodega",   "Datos":  {}};
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

    return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  } 

 public insert(bodega: Bodega){
   
    let json = {   "Metodo": "postBodega",   "Datos": bodega  }; 

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
}


public delete(bodega: Bodega){
  
    let json = {   "Metodo": "deleteBodega",   "Datos": bodega  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());


}

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/bodega.service.ts